import Handlebars from "handlebars";
export class BaseHandlebarsAdapter {
    engine;
    resolvedFunctions = new Map();
    toAwait = [];
    constructor() {
        this.engine = Handlebars.create();
    }
    async(fn) {
        return (() => {
            if (this.resolvedFunctions.has(fn)) {
                return this.resolvedFunctions.get(fn);
            }
            const result = fn();
            if (result instanceof Promise) {
                const promise = result.then((r) => this.resolvedFunctions.set(fn, r));
                this.toAwait.push(promise);
            }
            else {
                return result;
            }
        });
    }
    partial = (template) => {
        return () => this.engine.compile(template, { compat: true });
    };
    async render(template, data, templates = {}) {
        const compiledTemplates = Object.fromEntries(Object.entries(templates).map(([name, template]) => ([name, this.engine.compile(template, { compat: true })])));
        const compiled = this.engine.compile(template, { compat: true });
        let result;
        do {
            this.toAwait = [];
            result = compiled(data, { partials: compiledTemplates, allowedProtoMethods: {
                    isAttribute: true,
                    isAssociation: true,
                    isCustomType: true,
                } });
            await Promise.all(this.toAwait);
        } while (this.toAwait.length > 0);
        return result;
    }
}
//# sourceMappingURL=base.js.map